import { render } from "./PetitionLayout.vue?vue&type=template&id=fde04cae"
import script from "./PetitionLayout.vue?vue&type=script&lang=js"
export * from "./PetitionLayout.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__